/* 🤖 this file was generated by svg-to-ts */
export const iconLink: {
  name: 'link';
  data: string;
} = {
  name: 'link',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m9.3 24.21-6.72 3.92-2.49 1.43-2.49-1.43-6.85-3.92-2.49-1.43V9.21l2.49-1.43 6.79-3.92 2.49-1.43 2.49 1.43 6.79 3.92 2.49 1.43v13.57l-2.49 1.43z"/><path fill="currentColor" d="M9.24 12.07v7.85l6.78 3.92 6.79-3.92v-7.85l-6.79-3.92z"/></svg>`,
};
